<template>
  <div class="filter">
    <q-form
      @submit.prevent="playerLookup(playerId)"
      class="filter__player-search"
    >
      <q-input
        borderless
        v-model="playerId"
        mask="###################"
        label="Enter a Player ID"
        clearable
        clear-icon="close"
        style="width: 100%;
    margin-right: 8px;"
      >
        <template v-slot:prepend>
          <q-icon name="search" />
        </template>
      </q-input>
      <q-btn
        type="submit"
        rounded
        unelevated
        no-caps
        color="secondary"
        label="Search"
        style="height: 40px;"
      />
    </q-form>
  </div>
</template>

<script>
export default {
  name: "PlayerSelector",

  data() {
    return {
      playerId: null,
    };
  },
  methods: {
    // this.$route.query.player_id
    playerLookup(searchedPlayerId) {
      if (searchedPlayerId && searchedPlayerId.length > 0) {
        // Emit update filter to parent page for child components to render depending on filter arguments.
        this.$store.commit("SET_PLAYER_ID", {
          playerId: searchedPlayerId,
        });
        const filterSelection = {
          playerId: searchedPlayerId,
          siteId: 0,
          networkId: this.$store.state.userDetails.networkId
            ? this.$store.state.userDetails.networkId
            : 0,
          operatorId: this.$store.state.userDetails.operatorId
            ? this.$store.state.userDetails.operatorId
            : 0,
        };
        // Push filter selection to parent to update the other child components.
        this.$emit("updateFilter", filterSelection);
      }
    },
  },
  mounted() {
    // Check to see if a route query is present, else lookup store state if avaliable or return null until manual search made using input.
    if (this.$route.query.playerId) {
      this.playerId = this.$route.query.playerId;
      this.playerLookup(this.playerId);
    } else {
      this.playerId = this.$store.state.playerId
        ? this.$store.state.playerId
        : null;
    }
  },
};
</script>

<style lang="scss" scoped>
.filter {
  display: flex;
  flex: auto;
  flex-direction: column;
  // Slightly larger min-width than normal due to text heavy fitler options values causing styling breaks in tablet mode
  @media only screen and (min-width: 860px) {
    flex-direction: row;
  }
  &__player-search {
    display: flex;
    width: 100%;
    align-content: center;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
